module.exports = __webpack_public_path__ + "static/5-c6e1410ba82082ebce8ea3ec305c5eb6.jpg";